import i18n from "i18next";
import {initReactI18next} from "react-i18next";

const resources = {
  eng: {
    translation: {
      "virtual": "Virtual",
      "VirtualTennis": "Virtual Tennis",
      "VirtualFootball": "Virtual Football",
      "VirtualHorseRacing": "Virtual Horse Racing",
      "VirtualHorseBetShop": "Virtual Horse",
      "VirtualBicycle": "Virtual Cycling",
      "VirtualGreyhounds": "Virtual Greyhounds",
      "VirtualGreyhoundsBetShop": "Virtual Greyhounds",
      "PenaltyKicks": "Penalty Kicks",
      "VirtualFootballLeague": "Virtual Football League",
      "DragRacing": "Drag Racing",
      "MarbleRacing": "Marble Racing",
      "SpinToWin": "Spin To Win",
      "SpinToWinDeluxe": "Spin To Win Deluxe",
      "games rules": "GAMES LIST",
      "select game type": "SELECT GAME TYPE",
      "bet shop": "BETSHOP",
      "web": "WEB",
      "view games history": 'VIEW GAMES HISTORY',
      "rdr": 'Round / Date / Result',
      "round id": "ROUND ID"
    }
  },
  arm: {
    translation: {
      "virtual": "Վիրտուալ",
      "instant": "Ակնթարթային",
      "VirtualTennis": "Վիրտուալ թենիս",
      "VirtualFootball": "Վիրտուալ ֆուտբոլ",
      "VirtualHorseRacing": "Վիրտուալ ձիարշավ",
      "VirtualHorseBetShop": "Վիրտուալ ձիարշավ",
      "VirtualBicycle": "Վիրտուալ հեծանվասպորտ",
      "VirtualGreyhounds": "Վիրտուալ շների վազք",
      "VirtualGreyhoundsBetShop": "Վիրտուալ շների վազք",
      "PenaltyKicks": "11-մետրանոց հարվածներ",
      "VirtualFootballLeague": "Վիրտուալ ֆուտբոլային լիգա",
      "DragRacing": "Դրեգ-ռեյսինգ",
      "MarbleRacing": "Մարբլ ռեյսինգ",
      "games rules": "ԽԱՂԵՐԻ ՑԱՆԿ",
      "select game type": "ԸՆՏՐԵՔ ԽԱՂԻ ՏԵՍԱԿԸ",
      "bet shop": "ԲԵԹՇՈՓ",
      "web": "ՎԵԲ",
      "view games history": 'ԴԻՏԵՔ ԽԱՂԵՐԻ ՊԱՏՄՈՒԹՅՈՒՆԸ',
      "rdr": 'ՌԱՈՒՆԴ / ԱՄՍԱԹԻՎ / ԱՐԴՅՈՒՆՔ',
      "round id": "ՌԱՈՒՆԴԻ ID"
    }
  },
  fre: {
    translation: {
      "VirtualTennis": "Tennis virtuel",
      "VirtualFootball": "Football virtuel",
      "VirtualHorseRacing": "Courses de chevaux virtuelles",
      "VirtualHorseBetShop": "Courses de chevaux virtuelles",
      "VirtualBicycle": "Cyclisme virtuel",
      "VirtualGreyhounds": "Course de chiens virtuelle",
      "VirtualGreyhoundsBetShop": "Course de chiens virtuelle",
      "PenaltyKicks": "Penalty",
      "VirtualFootballLeague": "Ligue de football virtuelle",
      "DragRacing": "Dragster",
      "MarbleRacing": "Course de marbre",
      "games rules": "LISTE DES JEUX",
      "select game type": "SÉLECTIONNER LE TYPE DE JEU",
      "bet shop": "BETSHOP",
      "web": "WEB",
      "view games history": "VOIR L'HISTORIQUE DES JEUX",
      "rdr": 'Tour / Date / Résultat',
      "round id": "ID ROND"
    }
  }
};

i18n.use(initReactI18next).init({resources, lng: "eng", debug: false,
  keySeparator: false, // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

export default i18n;